<div class="card flex justify-content-center" *mobxAutorun>
  <p-chart
    type="doughnut"
    [data]="chartData"
    width="400px"
    height="400px"
    (click)="editWeighting()"
  ></p-chart>
</div>

<p-dialog
  header="Update Sensitivity Score Weightings"
  [(visible)]="showEditWeightings"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <div *ngIf="updateWeightingDto" class="grid p-3">
    <div class="w-full grid mb-3">
      <div class="col-7"><label>Organisation Long Term</label></div>
      <div class="col-5">
        <input
          pInputText
          [(ngModel)]="updateWeightingDto.organisationLongTerm"
          type="number"
          step="0.01"
        />
      </div>
    </div>
    <div class="w-full grid mb-3">
      <div class="col-7"><label>Organisation Short Term</label></div>
      <div class="col-5">
        <input
          pInputText
          [(ngModel)]="updateWeightingDto.organisationShortTerm"
          type="number"
          step="0.01"
        />
      </div>
    </div>
    <div class="w-full grid mb-3">
      <div class="col-7"><label>Enhanced Checklist</label></div>
      <div class="col-5">
        <input
          pInputText
          [(ngModel)]="updateWeightingDto.enhancedChecklist"
          type="number"
          step="0.01"
        />
      </div>
    </div>
    <div class="w-full grid mb-3">
      <div class="col-7"><label>Lead Time</label></div>
      <div class="col-5">
        <input pInputText [(ngModel)]="updateWeightingDto.leadTime" type="number" step="0.01" />
      </div>
    </div>
    <span *ngIf="sumOfWeights != 1" class="text-red-400">Sum of weights must equal 1</span>
  </div>
  <p-footer>
    <button
      type="button"
      pButton
      (click)="saveWeightings()"
      label="Save"
      [disabled]="sumOfWeights != 1"
    ></button>
  </p-footer>
</p-dialog>
